import useUpgradesStore from "@/store/useUpgradesStore";
import { type TileIndex } from "@/types/tile";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class HuntersLodgeBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.HUNTERS_LODGE;

	public get suppliesTileIndexes(): Set<TileIndex> {
		return new Set<TileIndex>(
			// zasobuje len 1 tannery
			Array.from(super.suppliesTileIndexes).slice(0, 1),
		);
	}

	public get requirements(): Map<ResourceType, number> {
		const requirements = new Map<ResourceType, number>(super.requirements);

		// Apply upgrades
		let connectionRequirement =
			(requirements.get(ResourceType.SETTLEMENT_CONNECTION) as number) ||
			0;
		if (
			useUpgradesStore().getCurrentLevelById(UpgradeIds.forest_paths) > 0
		) {
			connectionRequirement = 0;
		}
		requirements.set(
			ResourceType.SETTLEMENT_CONNECTION,
			connectionRequirement,
		);

		return requirements;
	}
}

export default HuntersLodgeBuildingTileEntity;
